export enum TurnStateEnum {
    waitingTurnHolderValidation = 'waitingTurnHolderValidation',
    waitingEndOfTurnValidation = 'waitingEndOfTurnValidation',
    turnFinished = 'turnFinished'
}
